import { useContext } from "react";
import { ModalsContext } from "./context";

export function useModalsHook() {
  return useContext(ModalsContext);
}
